import { render, staticRenderFns } from "./jumpLinkCom.vue?vue&type=template&id=9e8c97d4&scoped=true"
import script from "./jumpLinkCom.vue?vue&type=script&lang=js"
export * from "./jumpLinkCom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e8c97d4",
  null
  
)

export default component.exports